import { apiClient } from './apiClient';

export type TemplateType = {
  id: number;
  name: string;
};

export const TemplateTypeNames = {
  TASK: 'Task',
  FILING: 'Filing',
  BILLING: 'Billing',
  PAYMENT: 'Payment',
  TAX_PAYMENT: 'Tax Payment',
  SETUP: 'Setup',
} as const;

export type TemplateTypeName =
  (typeof TemplateTypeNames)[keyof typeof TemplateTypeNames];

export const getTemplateTypes = (): Promise<TemplateType[]> =>
  apiClient.get('/template-types', {});
